import { MultiSelectDropdown } from '@joor/design-system'
import styled from 'styled-components'

export const StyledMultiSelectDropdown = styled(MultiSelectDropdown)`
  max-width: 440px;
  margin-bottom: 14px;
`
